// extracted by mini-css-extract-plugin
export default {"text":"Quizz_text__1g9hW","container":"Quizz_container__h6Q3Q","items":"Quizz_items__xUCdn"};